import { render, staticRenderFns } from "./KeywordsFame.vue?vue&type=template&id=68a07791&scoped=true"
import script from "./KeywordsFame.vue?vue&type=script&lang=js"
export * from "./KeywordsFame.vue?vue&type=script&lang=js"
import style0 from "./KeywordsFame.vue?vue&type=style&index=0&id=68a07791&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a07791",
  null
  
)

export default component.exports